/* IMPORT */
import { writable } from '../objects/callable.js';
import ObservableClass from '../objects/observable.js';
import { callStack } from './debugger.js';
function observable(value, options) {
    const stack = callStack();
    return writable(new ObservableClass(value, options), stack);
}
/* EXPORT */
export default observable;
